import classNames from "classnames";
import React from "react";

import styles from "./index.module.scss";

interface Props {
  caption?: string | null;
  forceRatio?: boolean;
  src: string;
}

const ImageBlock: React.FC<Props> = (props: Props) => {
  const { caption, forceRatio = false, src } = props;
  return (
    <div className={styles.container}>
      <div
        className={classNames(
          styles.imageWrapper,
          forceRatio && styles.withRatio,
        )}
      >
        <div
          className={classNames(
            styles.imageWrapperInner,
            forceRatio && styles.withRatio,
          )}
        >
          <img
            src={src}
            className={classNames(styles.image, forceRatio && styles.withRatio)}
          />
        </div>
      </div>

      {!caption ? null : <p className={styles.caption}>{caption}</p>}
    </div>
  );
};

export { ImageBlock };
